export default __webpack_public_path__ + "static/media/contact-dark.f2d597f4.svg";